export default () => ({
  price: []
})
